<template>
	<div class="history_list">
		<div class="history_list_header">
			历史记录
			<span v-if="showMore" @click="onClick">查看更多记录 <van-icon name="arrow" /></span>
		</div>
		<van-list v-model="modelLoading" :finished="finished" :finished-text="finishedText" @load="onLoad">
			<div class="history_list_body" v-for="(item, index) in list" :key="index">
				<div class="time">{{ item.date }}</div>
				<history-list-item
					v-for="(sonItem, sonIndex) in item.list"
					:key="sonIndex"
					:time="sonItem.time"
					:list="sonItem.list"
					:showUpdate="$route.query.previewType != 'doctor'"
					@onUpdate="onUpdate(sonItem)"
					@onDelete="onDelete(sonItem)"
				>
				</history-list-item>
			</div>
		</van-list>
		<van-empty v-if="list.length === 0" description="暂无数据"></van-empty>
	</div>
</template>
<script>
export default {
    name: 'historyListCard',
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        showMore: {
            type: Boolean,
            default: true
        },
        list: {
            type: Array,
            default: () => []
        },
        finished: {
            type: Boolean,
            default: false
        },
        finishedText: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            statusText: {
                1: '手动填写',
                2: '设备同步'
            }
        }
    },
    computed: {
        isDoctor () {
            return this.$route.query.previewType === 'doctor'
        },
        modelLoading: {
            get () {
                return this.loading
            },
            set (val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        onClick () {
            this.$emit('more')
        },
        onUpdate (item) {
            this.$emit('onUpdate', item)
        },
        onDelete (item) {
            this.$emit('onDelete', item)
        },
        onLoad () {
            this.$emit('load')
        }
    }
}
</script>
<style lang="less" scoped>
.history_list {
	background-color: #ffffff;
	border-radius: 16px 16px 0 0;
	overflow: hidden;
	padding: 40px 32px;

	&_header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 34px;
		color: #000000;
		font-weight: 500;
		margin-bottom: 50px;

		span {
			color: @gray-9;
			font-size: 26px;
			font-weight: 400;
		}
	}

	&_body {
		border-bottom: 2px solid #f0f0f0;
		margin-bottom: 40px;

		.time {
			font-size: 28px;
			color: #1f2329;
			margin-bottom: 40px;
			display: flex;
			align-items: center;

			&::before {
				content: '';
				display: block;
				width: 6px;
				background-color: @primary;
				height: 26px;
				margin-right: 10px;
				margin-top: -1px;
			}
		}
	}
}
</style>
